(function (Drupal, once) {
  Drupal.behaviors.sidebarToggle = {
    attach(context, settings) {
      const toggleButtons = once('sidebar-toggle', '#toggleSidebarBtn', context);
      for (const btn of toggleButtons) {
        btn.addEventListener('click', () => {
          const collapsed = document.body.classList.toggle('sidebar-collapsed');
          btn.textContent = collapsed ? '☰' : '❮';
        });

        // Initialize correct icon on load.
        const collapsed = document.body.classList.contains('sidebar-collapsed');
        btn.textContent = collapsed ? '☰' : '❮';
      }
    }
  };
})(Drupal, once);
 